"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerHeader = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@mui/material/styles");
var Drawer_1 = __importDefault(require("@mui/material/Drawer"));
var AppBar_1 = __importDefault(require("@mui/material/AppBar"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var Menu_1 = __importDefault(require("@mui/material/Menu"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_router_dom_1 = require("react-router-dom");
var es_cookie_1 = require("es-cookie");
var Link_1 = __importDefault(require("@mui/material/Link"));
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var List_1 = __importDefault(require("@mui/material/List"));
var CssBaseline_1 = __importDefault(require("@mui/material/CssBaseline"));
var Divider_1 = __importDefault(require("@mui/material/Divider"));
var Menu_2 = __importDefault(require("@mui/icons-material/Menu"));
var ChevronLeft_1 = __importDefault(require("@mui/icons-material/ChevronLeft"));
var ChevronRight_1 = __importDefault(require("@mui/icons-material/ChevronRight"));
var ListItemButton_1 = __importDefault(require("@mui/material/ListItemButton"));
var ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
var ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
var LocalParking_1 = __importDefault(require("@mui/icons-material/LocalParking"));
var Settings_1 = __importDefault(require("@mui/icons-material/Settings"));
var Schedule_1 = __importDefault(require("@mui/icons-material/Schedule"));
var EventAvailable_1 = __importDefault(require("@mui/icons-material/EventAvailable"));
var react_avatar_1 = __importDefault(require("react-avatar"));
var drawerWidth = 240;
var openedMixin = function (theme) { return ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
}); };
var closedMixin = function (theme) {
    var _a;
    return (_a = {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            width: "calc(".concat(theme.spacing(7), " + 1px)")
        },
        _a[theme.breakpoints.up('sm')] = {
            width: "calc(".concat(theme.spacing(8), " + 1px)"),
        },
        _a);
};
exports.DrawerHeader = (0, styles_1.styled)('div')(function (_a) {
    var theme = _a.theme;
    return (__assign({ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: theme.spacing(0, 1) }, theme.mixins.toolbar));
});
var AppBar = (0, styles_1.styled)(AppBar_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'open'; },
})(function (_a) {
    var theme = _a.theme, open = _a.open;
    return (__assign({ zIndex: theme.zIndex.drawer + 1, transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }) }, (open && {
        marginLeft: drawerWidth,
        width: "calc(100% - ".concat(drawerWidth, "px)"),
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    })));
});
var Drawer = (0, styles_1.styled)(Drawer_1.default, { shouldForwardProp: function (prop) { return prop !== 'open'; } })(function (_a) {
    var theme = _a.theme, open = _a.open;
    return (__assign(__assign({ width: drawerWidth, flexShrink: 0, whiteSpace: 'nowrap', boxSizing: 'border-box' }, (open && __assign(__assign({}, openedMixin(theme)), { '& .MuiDrawer-paper': openedMixin(theme) }))), (!open && __assign(__assign({}, closedMixin(theme)), { '& .MuiDrawer-paper': closedMixin(theme) }))));
});
function NavBar(_a) {
    var userManager = _a.userManager;
    var theme = (0, styles_1.useTheme)();
    var _b = react_1.default.useState(false), auth = _b[0], setAuth = _b[1];
    var _c = react_1.default.useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var _d = react_1.default.useState('Amenity Reservation'), pageTitle = _d[0], setPageTitle = _d[1];
    var _e = react_1.default.useState(false), open = _e[0], setOpen = _e[1];
    var handleDrawerOpen = function () {
        setOpen(true);
    };
    var handleDrawerClose = function () {
        setOpen(false);
    };
    var avatarOpen = Boolean(anchorEl);
    var navigate = (0, react_router_dom_1.useNavigate)();
    var checkLogin = function () {
        var token = (0, es_cookie_1.get)('token');
        if (token) {
            userManager.validateToken(token).then(function (_result) {
                if (userManager.loggedIn) {
                    setAuth(true);
                }
                else {
                    setAuth(false);
                }
            });
        }
    };
    react_1.default.useEffect(function () {
        if (!userManager) {
            return;
        }
        checkLogin();
        var timer = setTimeout(function () {
            checkLogin();
            clearTimeout(timer);
        }, 1000);
    }, [auth]);
    var handleMenu = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var logout = function () {
        var token = (0, es_cookie_1.get)('token');
        if (!token) {
            return;
        }
        userManager.logout(token).then(function (result) {
            if (result === false) {
                return;
            }
            setAuth(false);
            navigate('/');
        });
        handleClose();
    };
    var toolBar;
    if (auth) {
        toolBar = (react_1.default.createElement(Box_1.default, { sx: { display: 'flex' } },
            react_1.default.createElement(CssBaseline_1.default, null),
            react_1.default.createElement(AppBar, { position: "fixed", open: open },
                react_1.default.createElement(Toolbar_1.default, { sx: { backgroundColor: '#f37f30' } },
                    react_1.default.createElement(IconButton_1.default, { color: "inherit", "aria-label": "open drawer", onClick: handleDrawerOpen, edge: "start", sx: __assign({ marginRight: 5 }, (open && { display: 'none' })) },
                        react_1.default.createElement(Menu_2.default, null)),
                    react_1.default.createElement(Typography_1.default, { variant: "h6", sx: { flexGrow: 1 } }, pageTitle),
                    react_1.default.createElement(IconButton_1.default, { "aria-label": "account of current user", "aria-controls": "menu-appbar", "aria-haspopup": "true", onClick: handleMenu, color: "inherit", size: "large" },
                        react_1.default.createElement(react_avatar_1.default, { md5Email: userManager.md5Email, name: userManager.fullname, color: "#93C83E", size: "40", round: true })),
                    react_1.default.createElement(Menu_1.default, { id: "menu-appbar", anchorEl: anchorEl, anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right',
                        }, keepMounted: true, transformOrigin: {
                            vertical: 'top',
                            horizontal: 'right',
                        }, open: avatarOpen, onClose: handleClose },
                        react_1.default.createElement(MenuItem_1.default, { onClick: function () { return navigate('myreservations'); } }, "My Reservations"),
                        react_1.default.createElement(MenuItem_1.default, { onClick: logout }, "Logout")))),
            react_1.default.createElement(Drawer, { variant: "permanent", open: open },
                react_1.default.createElement(exports.DrawerHeader, null,
                    react_1.default.createElement(IconButton_1.default, { onClick: handleDrawerClose }, theme.direction === 'rtl' ? react_1.default.createElement(ChevronRight_1.default, null) : react_1.default.createElement(ChevronLeft_1.default, null))),
                react_1.default.createElement(Divider_1.default, null),
                react_1.default.createElement(List_1.default, null,
                    react_1.default.createElement(Link_1.default, { href: "/parking", onClick: function (e) {
                            e.preventDefault();
                            navigate('/parking');
                            setPageTitle('Visitor Parking Registration');
                        }, color: "inherit", underline: "none" },
                        react_1.default.createElement(Tooltip_1.default, { title: "Visitor Parking Registration", placement: "right-end" },
                            react_1.default.createElement(ListItemButton_1.default, { key: "parking" },
                                react_1.default.createElement(ListItemIcon_1.default, { style: { paddingLeft: '5px' } },
                                    react_1.default.createElement(LocalParking_1.default, null)),
                                react_1.default.createElement(ListItemText_1.default, { primary: "Parking" })))),
                    react_1.default.createElement(Link_1.default, { href: "/reservation", onClick: function (e) {
                            e.preventDefault();
                            navigate('reservation');
                            setPageTitle('Amenity Reservation');
                        }, color: "inherit", underline: "none" },
                        react_1.default.createElement(Tooltip_1.default, { title: "Amenity Reservation" },
                            react_1.default.createElement(ListItemButton_1.default, { key: "reservation" },
                                react_1.default.createElement(ListItemIcon_1.default, { style: { paddingLeft: '5px' } },
                                    react_1.default.createElement(EventAvailable_1.default, null)),
                                react_1.default.createElement(ListItemText_1.default, { primary: "Reserve Amenity" })))),
                    react_1.default.createElement(Link_1.default, { href: "/elevator-booking", onClick: function (e) {
                            e.preventDefault();
                            navigate('elevator-booking');
                            setPageTitle('Elevator Booking');
                        }, color: "inherit", underline: "none" },
                        react_1.default.createElement(Tooltip_1.default, { title: "Elevator Booking" },
                            react_1.default.createElement(ListItemButton_1.default, { key: "elevator-booking" },
                                react_1.default.createElement(ListItemIcon_1.default, { style: { paddingLeft: '5px' } },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faDolly, size: "lg" })),
                                react_1.default.createElement(ListItemText_1.default, { primary: "Elevator Booking" })))),
                    react_1.default.createElement(Link_1.default, { href: "/myreservations", onClick: function (e) {
                            e.preventDefault();
                            navigate('myreservations');
                            setPageTitle('My Reservations');
                        }, color: "inherit", underline: "none" },
                        react_1.default.createElement(Tooltip_1.default, { title: "My Reservations" },
                            react_1.default.createElement(ListItemButton_1.default, { key: "myreservations" },
                                react_1.default.createElement(ListItemIcon_1.default, { style: { paddingLeft: '5px' } },
                                    react_1.default.createElement(Schedule_1.default, null)),
                                react_1.default.createElement(ListItemText_1.default, { primary: "My reservations" }))))),
                (userManager.isAdmin || userManager.isParkingAdmin) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Divider_1.default, null),
                    react_1.default.createElement(List_1.default, null,
                        react_1.default.createElement(Link_1.default, { href: "/admin", onClick: function (e) {
                                e.preventDefault();
                                navigate('admin');
                                setPageTitle('Administration');
                            }, color: "inherit", underline: "none" },
                            react_1.default.createElement(Tooltip_1.default, { title: "Administration" },
                                react_1.default.createElement(ListItemButton_1.default, { key: "administration" },
                                    react_1.default.createElement(ListItemIcon_1.default, { style: { paddingLeft: '5px' } },
                                        react_1.default.createElement(Settings_1.default, null)),
                                    react_1.default.createElement(ListItemText_1.default, { primary: "Administration" }))))))))));
    }
    else {
        toolBar = (react_1.default.createElement(AppBar, { position: "static" },
            react_1.default.createElement(Toolbar_1.default, { sx: { backgroundColor: '#f37f30' } },
                react_1.default.createElement(Typography_1.default, { variant: "h6", sx: { flexGrow: 1 } }),
                react_1.default.createElement(Button_1.default, { color: "inherit", href: "/login" }, "Amenities reservation login"))));
    }
    return (react_1.default.createElement("div", null, toolBar));
}
exports.default = NavBar;
